import { BrowserRouter, useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";
import { AppRoutes } from "@/router";
import { I18nextProvider } from "react-i18next";
import i18n from "@/i18n";
import { FavoritesProvider } from "@/hooks/FavoritesProvider";
import CompareBar from "@/components/feature/CompareBar";
import AccessibilityWidget from "@/components/feature/AccessibilityWidget";
import DemoFeedbackRecorder from "@/components/feature/DemoFeedbackRecorder";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useLayoutEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    window.requestAnimationFrame(() => {
      document.querySelector(hash)?.scrollIntoView({ block: 'start' });
    });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <FavoritesProvider>
          <ScrollToTop />
          <AppRoutes />
          <CompareBar />
          <AccessibilityWidget />
          <DemoFeedbackRecorder />
        </FavoritesProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
